import { useRootStore } from '@/stores/root.store';
import { useUserStore } from '../stores/user.store';
import DashService from '../services/api/dash.service';
import LoadingLayout from '@/components/layouts/loading-layout.vue';

export default {
  name: 'callback',
  path: '/callback',
  meta: { authenticated: false, activeUser: false, title: 'Redirecting...', enabled: true },
  component: LoadingLayout,
  beforeEnter: async (to) => {
    const { code, error, state } = to.query;

    try {
      // check for invalid state, code, or error
      if (error || !state || !code) {
        throw new Error('Invalid state, code, or error present.');
      }

      // fetch cookie state and clear it out
      const cookieState = useRootStore().cookieService.getStateFromCookie();
      const verifiedState = cookieState === state;
      useRootStore().cookieService.clearStateCookie();

      // remove all query parameters
      window.history.replaceState(null, null, window.location.pathname);

      // exchange the code
      if (code && verifiedState) {
        const token = await DashService.getTokenFromCode(
          code,
          useRootStore().configuration.oidClientId,
          useRootStore().configuration.backendUrl
        );
        const jwt = token.access_token;
        const expiry = token.expires_in;

        // login the user with the JWT
        useUserStore().loginFromJwt(jwt, expiry);
        // Clear auth domain cookie now that we have authenticated
        useRootStore().cookieService.clearAuthCookie();
      } else {
        throw new Error('Invalid state.');
      }
    } catch (e) {
      console.error(e);
      return {
        name: 'error',
        query: {
          code: '0001',
        },
      };
    }

    // grab the redirect path
    const redirectTo = useRootStore().cookieService.getRedirectFromCookie();
    useRootStore().cookieService.clearRedirectCookie();

    // if redirect exists, send them there, otherwise send them home
    if (redirectTo) {
      return { path: redirectTo };
    } else {
      return { path: '/' };
    }
  },
};
